<div [class.resize]="resize" [class.dual-view-panel]="dualViewEnabled" class="inverse-surface overlay">
  <!-- Imagery/Basemap Toggle Section -->
  <div class="row row-cols-2 text-center">
    <div class="col">
      <button [class.selected]="isImageryShown" class="icon-button" (click)="onImageryClick()">
        <img class="icon" src="{{ imageryIcon }}" />
      </button>
      <br />
      Imagery
    </div>
    <div class="col" [matTooltip]="viewerService.is3DMode() ? 'Basemap not available in 3D mode.' : ''">
      <button
        [class.selected]="!isImageryShown"
        [class.disabled]="viewerService.is3DMode()"
        class="icon-button"
        [disabled]="viewerService.is3DMode()"
        (click)="onBasemapClick()">
        <img class="icon" src="{{ baseMapIcon }}" />
      </button>
      <br />
      Basemap
    </div>
  </div>

  <mat-divider class="divider"></mat-divider>

  <!-- Gray Sky Contrast Section -->
  @if ((flagService.getFlags$() | async)?.[FeatureFlags.ENHANCE_CONTRAST] && autoContrastAllowed) {
  <mat-checkbox
    class="mat-checkbox-slim"
    (change)="onContrastToggle($event.checked)"
    [disabled]="!(isActivatedAutoContrast || centerAOI?.isGraySky())"
    [checked]="isActivatedAutoContrast">
    <mat-icon
      class="mirror small-icon"
      [matTooltip]="centerAOI?.isGraySky() ? '' : 'Select a Gray Sky collection to use this feature'">
      auto_fix_high
    </mat-icon>
    Gray Sky Contrast
  </mat-checkbox>
  }

  <!-- Overlay Layers Section (Drag & Drop) -->
  @if (overlayLayers?.length) {
  <div>
    <div cdkDropList (cdkDropListDropped)="onOverlayOrderChange($event)">
      @for (layer of overlayLayers; track layer.id) {
      <div class="overlay-widget" cdkDrag>
        <div class="drag-placeholder" *cdkDragPlaceholder></div>

          <!-- Layer visibility checkbox -->
          <mat-checkbox
                  [checked]="layer.visible"
                  (change)="toggleLayerVisibility(layer)"
                  class="layer-checkbox">{{ layer.name }}
          </mat-checkbox>
      </div>
      }
    </div>
  </div>
  }
</div>
